import * as React from 'react';
import './Layout.css';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Sidebar from '../Sidebar/Index';
import { authClient } from '../../Utils/Common';
import { toast } from 'react-toastify';
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));
export default function Layout({ children, refState, setRefState, setRefStatenew, refStatenew }) {
    React.useEffect(() => {
        const checkTokenExpiry = async () => {
            const accessToken = await authClient.tokenManager.get("accessToken");
            if (accessToken) {
                const expiryTime = new Date(accessToken.expiresAt * 1000);
                const expiresIn = expiryTime - Date.now();
            } else {
                console.warn("No access token found.");
            }
        };
        checkTokenExpiry();
        const handleTokenExpiry = (key) => {
            toast.error("Session Expired")
            console.warn(`${key} expired. Logging out user...`);
            authClient.signOut();
        };
        authClient.tokenManager.on("expired", handleTokenExpiry);
        return () => {
            authClient.tokenManager.off("expired", handleTokenExpiry);
        };
    }, []);
    return (
        <Box sx={{ display: 'flex' }}>
            <Sidebar setRefState={setRefState} refState={refState} setRefStatenew={setRefStatenew} refStatenew={refStatenew} />
            <Box component='main' sx={{ flexGrow: 1, p: 3 }} className='padding-set'>
                <DrawerHeader />
                {children}
            </Box>
        </Box>
    );
}